<template lang="pug">
.settings
  HScroll()
    transition(name='simple-fade' mode='out-in')
      //- STEP 1 (action selector)
      ActionSelectorMenu(:items='actionItems' v-model='actionType' size='35')

    transition(name='simple-fade' mode='out-in')
      //- STEP 2 (visible if actionType is selected)
      div(v-if='actionType')
        template(v-if='actionType === "UNIX"')
          UnixPrintPanel
        template(v-else-if='actionType === "ALL_SALES"')
          SalesSummaryPrintPanel
        template(v-else-if='actionType === "ALL_SALES_AND_COMM"')
          SalesAndCommPrintPanel
        //- template(v-else)
        //-   GenericCard.actionDetail(size='45')
        //-     .d-flex.flex-column.px-3.py-4
        //-       .text-large {{ actionType }}

    //- .scrollable
    //-   .d-flex.flex-column
    //-     UnixPrintPanel
    //-     SalesSummaryPrintPanel
    //-     SalesAndCommPrintPanel

</template>

<script>
import UnixPrintPanel from '@/components/_cs/print/panels/UnixPrintPanel.vue';
import SalesSummaryPrintPanel from '@/components/_cs/print/panels/SalesSummaryPrintPanel.vue';
import SalesAndCommPrintPanel from '@/components/_cs/print/panels/SalesAndCommPrintPanel.vue';

export default {
  data: () => ({
    customer: null,
    actionType: null,
    // actionDetail: null,
    receiptType: -1,
    deliveryType: -1,
    shipmentMethod: -1,
    currentStep: 0,

    STEP_SELECT_ACTION: 1,
    STEP_PERFORM_ACTION: 3,

    actionItems: {
      UNIX: 'รายการขายส่งเข้า UNIX',
      ALL_SALES: 'สรุปรายการขาย',
      ALL_SALES_AND_COMM: 'สรุปรายการขายและค่าคอม',
    },
  }),
  watch: {
    actionType(newVal) {
      if (newVal) {
        this.setCurrentStep(this.STEP_SELECT_ACTION);
      }
    },
  },
  computed: {
    isActionDetailsValid() {
      return this.receiptType !== -1
          && this.deliveryType !== -1
          && this.shipmentMethod !== -1;
    },
  },
  methods: {
    setCurrentStep(step) {
      // change step to step - 1 => wait 50ms => change step to the actual value
      // so the change is always noticed by the HSrcoll component
      // HSroll will then scoll to the right, so the new view is visible to the user
      this.currentStep = step - 1;
      setTimeout(() => {
        this.currentStep = step;

        //
        // 1. PREPARE the data for each STEP
        // 2. RESET the data gathered from further steps
        //    so the data won't be mixed up
        //

        // STEP 1
        if (step < this.STEP_SELECT_ACTION) {
          this.actionType = null;
        }
      }, 50);
    },
  },
  components: {
    UnixPrintPanel,
    SalesSummaryPrintPanel,
    SalesAndCommPrintPanel,
  },
};
</script>

<style lang="scss">
.settings {
  > .h-scroll {
    height: 100%;
  }
}
</style>
